<div class="btn-group btn-map" ng-if="$root.permissions.painelVisita.canReadTracking" title="Caminhamentos">
  <button ng-show="showButton()" class="btn" uib-popover-template="'template-caminhamentos-popover.html'" popover-placement="left-top" popover-trigger="focus">
    <i class="icon-paths" aria-hidden="true"></i>
  </button>
</div>

<script type="text/ng-template" id="template-caminhamentos-popover.html">
  <div class="list-group user-trackings">
    <p ng-hide="userTrackings.length">Nenhum caminhamento</p>
    <a href="#" class="list-group-item" ng-repeat="tracking in userTrackings" ng-click="setTracking(tracking, $event)" style="border: none; padding: 7px">
      <i ng-class="{'text-muted': !tracking.active}" class="fa fa-user" style="padding-right: 5px; {{ tracking.active ? ('color: #'  + tracking.cor) : ''}}"></i>&nbsp;{{tracking.nome_completo}}
    </a>
  </div>
</script>
